const loginPath = '/signin'
const dashboardPath = '/';

const paths = {
    dashboardPath,
    loginPath
  };
  
export default paths;